export default {
    setTariffSettings({ commit }, payload) {
        commit('setTariffSettings', payload);
    },
    setBalanceModalIsOpen({ commit }, payload) {
        commit('setBalanceModalIsOpen', payload);
    }
}